import { RouteObject } from 'react-router-dom';

import { UserSettings } from './UserSettings';

export const userSettingsRoute: RouteObject = {
  path: 'users',
  element: <UserSettings />,
};
